






























































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { VbSnackbarService, VbTooltipSlot } from 'bag-of-holding-library';
import ModalComponent from '@/shared/modal/modal.component.vue';
import LabelSlot from '@/shared/slots/label-slot.component.vue';
import Rules from '@/shared/rules/rules';
import DatePickerField from '@/shared/date-picker/date-picker-field.component.vue';
import Attendance from '@/domain/attendance/entity/attendance.entity';
import ModalOptions from '@/shared/modal/modal-options.entity';
import Skill from '@/domain/employees/entity/skill.entity';
import SkillType from '@/domain/employees/entity/skill-type.entity';
import SkillService from '@/domain/employees/service/skill.service';


@Component({
  components: {
    ModalComponent,
    LabelSlot,
    VbTooltipSlot,
    DatePickerField,
  },
})
export default class ResignationModal extends Vue {
  @Prop() show!: boolean;

  @Prop() showResignationModal!: boolean;

  private attendance = Attendance.of({});

  valid: boolean = false;

  private rules: Rules = new Rules();

  private skill: Skill = new Skill();

  private selectItems: any[] = [{
    text: 'Hard Skills',
    value: SkillType.HARD_SKILLS,
  },
  {
    text: 'Frameworks / Metodologias',
    value: SkillType.FRAMEWORKS_OR_METHODOLOGIES,
  },
  {
    text: 'Experiência de negócios',
    value: SkillType.BUSINESS_EXPERIENCE,
  },
  {
    text: 'Certificações',
    value: SkillType.CERTIFICATIONS,
  }];

  role: any = '';

  loading = false;

  selectedIndex = 0;

  private get optionsHandled(): ModalOptions {
    return {
      title: 'Mapeamento de skills',
      titleSize: '25px',
      description: '',
      showOk: true,
      labelOk: 'Salvar',
      disabledOk: !this.valid || this.loading,
      okColor: 'tabBlue',
      showCancel: !this.loading,
      labelCancel: 'Cancelar',
      width: 880,
    };
  }

  async save() {
    const { form }: any = this.$refs;

    if (form.validate()) {
      this.createSkill();
    }
  }

  createSkill() {
    this.loading = true;
    this.skill.active = true;
    SkillService.createNewSkill(this.skill)
      .then((resp: any) => {
        VbSnackbarService.showSuccess('Skill salva com sucesso e pendente de Aprovação');
      })
      .catch((err: any) => VbSnackbarService.handleHttpError(err))
      .finally(() => {
        this.loading = false;
        this.close();
      });
  }

  close() {
    if (!this.loading) {
      this.clear();
      this.$emit('cancelSuggest');
    }
  }

  clear() {
    this.role = '';
    this.skill.description = '';
    this.skill.observation = '';
  }

  selectButton(index) {
    this.selectedIndex = index;
  }
}
